import { render, staticRenderFns } from "./tentative-sales-edit.vue?vue&type=template&id=d65b4e48&"
import script from "./tentative-sales-edit.vue?vue&type=script&lang=js&"
export * from "./tentative-sales-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports